var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6C9.58172 6 6 9.58172 6 14C6 16.2091 6.89544 18.2091 8.34315 19.6569C8.56631 19.88 8.80259 20.0901 9.05074 20.2857C9.20505 20.4074 9.36394 20.5235 9.52712 20.6337C10.8039 21.4963 12.3431 22 14 22C15.8686 22 17.5876 21.3593 18.9493 20.2857C19.5999 19.7727 20.1689 19.1609 20.6337 18.4729C21.4963 17.1961 22 15.6569 22 14C22 12.1314 21.3593 10.4124 20.2857 9.05074C20.0901 8.80259 19.88 8.56631 19.6569 8.34315C19.4759 8.16218 19.2863 7.98985 19.0887 7.82681C17.7059 6.68556 15.933 6 14 6ZM7.71429 14C7.71429 15.7358 8.41784 17.3072 9.55533 18.4447L18.4447 9.55533C17.3072 8.41784 15.7358 7.71429 14 7.71429C10.5285 7.71429 7.71429 10.5285 7.71429 14Z",
    fill: "#050022"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.71a6bc1a2d8328e56c83f07e84e27213.svg";
export { ForwardRef as ReactComponent };